// @flow
import { connect } from 'react-redux'
import selectorComponent from './selectorComponent'
import { selectorActions } from 'components/selector/reducer'
import type { AppState } from 'stores'

function mapStateToProps ({ categorySelection, brackets }: AppState) {
  return {
    currentYear: categorySelection.year,
    currentModel: categorySelection.model,
    currentIncome: categorySelection.income,
    availableIncomeBrackets: brackets
  }
}

function mapDispatchToProps (dispatch) {
  return {
    modelChangeHandler: model => {
      dispatch(selectorActions.selector.model.set(model))
    },
    incomeChangeHandler: income => {
      dispatch(selectorActions.selector.income.set(income))
    },
    yearChangeHandler: year => {
      dispatch(selectorActions.selector.year.set(year))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(selectorComponent)



// WEBPACK FOOTER //
// ./src/components/selector/selectorContainer.js